export function splitCamelCaseLowerCase(x: string) {
  return x
    .split(/(?=[A-Z])/)
    .map((s) => s.toLowerCase())
    .join(' ')
    .replace('- ', '-');
}

export function capitalizeFirstLetter(x: string) {
  return x.charAt(0).toUpperCase() + x.slice(1);
}

// 'units_sold' -> 'Units Sold'
export function snakeToTitleCase(x: string) {
  return x.split('_').map(capitalizeFirstLetter).join(' ');
}
